import React, { useState } from 'react';
import { AvatarName } from '../../utils/Validate';

const ResetPasswordModal = ({ show, item, handleCancel, handleConfirm, tempPassword, loading }) => {
    const [copied, setCopied] = useState(false);
    if (!show) return null;

    return (
        <div
            className="modal fade show d-block reset-password-modal"
            tabIndex="-1"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Reset Password</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={handleCancel}
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">

                        <div className="d-flex align-items-center gap-3 mb-3">
                            <div style={{
                                width: '44px', height: '44px',
                                borderRadius: '50%',
                                backgroundColor: '#B5D4F4',
                                display: 'flex', alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: '500', fontSize: '14px',
                                color: '#0C447C', flexShrink: 0
                            }}>
                                {AvatarName(item?.FullName)}
                            </div>
                            <div>
                                <p className="mb-0 fw-500">{item?.FullName}</p>
                                <small className="text-muted">{item?.userName}</small>
                            </div>
                        </div>

                        {!tempPassword && (
                            <>
                                <div className="alert mb-3" style={{
                                    backgroundColor: '#FAEEDA',
                                    border: '0.5px solid #FAC775',
                                    color: '#633806',
                                    fontSize: '13px'
                                }}>
                                    A temporary password will be generated and returned.
                                    Please share it with the user securely.
                                </div>
                                <p className="text-muted" style={{ fontSize: '14px' }}>
                                    Are you sure you want to reset the password for this user?
                                </p>
                            </>
                        )}

                        {tempPassword && (
                            <div className="mt-2">
                                <div className="alert alert-success mb-2" style={{ fontSize: '13px' }}>
                                    ✅ Password has been reset successfully! Share the temporary password below with the user securely.
                                </div>
                                <label style={{ fontSize: '13px', fontWeight: '600' }}>
                                    Temporary Password
                                </label>
                                <div className="input-group mt-1">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={tempPassword}
                                        readOnly
                                        style={{ fontFamily: 'monospace', fontSize: '15px', letterSpacing: '1px' }}
                                    />

                                    <div className="input-group-append">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            title="Copy to clipboard"
                                            onClick={() => {
                                                navigator.clipboard.writeText(tempPassword);
                                                setCopied(true);
                                                setTimeout(() => setCopied(false), 2000);
                                            }}>
                                            <i className={`fas ${copied ? 'fa-check text-success' : 'fa-copy'}`}></i>
                                        </button>
                                    </div>
                                </div>
                                <small className="text-muted mt-1 d-block">
                                    The user must change this password on next login.
                                </small>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">

                        {!tempPassword && (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCancel}
                                    disabled={loading}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => handleConfirm(item)}
                                    disabled={loading}>
                                    {loading ? 'Resetting...' : 'Reset Password'}
                                </button>
                            </>
                        )}

                        {tempPassword && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleCancel}>
                                Close
                            </button>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ResetPasswordModal;